
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import IntoLogisticsCheckResult from '@/store/entities/Into-logistics-checkresult';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import appconst from '@/lib/appconst';
    import QRcode from 'qrcodejs2'
    import { GetPrintWorld } from '@/common/js/PrintWorld'
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)

    class EditLogistics {
        id: number;
        storeId: number;
        shipment: string;
        userCode: string;
        processTime?: Date;
        receiveStatus: number;
        imageGuid: string;
        reMark: string;
        shelfNumber: string;
        isConfirm: boolean;
        goodsImageGuid: string;
        //orderType: number;

    }

    @Component({
        name: "intoabroadLogistics",
    })
    export default class CreateLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        logistics: EditLogistics = new EditLogistics();
        warehouseCityId: number = 0;
        isSkip: boolean = false;
        isDisplay: string = '';
        imgUrl: string = '';
        selectDate: string = "";
        selectTime: string = "";
        oldReceiveStatus: number;
        isReadOnly = false;
        imgUploadUrl: string = '';
        goodsimgUrl: string = '';
        isLoadPrintList: boolean = false;
        //waerhouseOrderType: number = null;
        shelfNumberInfo: string = '';
        checkLoding = false;
        isNative: boolean = false;
        checkResult: IntoLogisticsCheckResult = null;
        titleList: Array<string> = [];
        storeaddressList: Array<storeaddressInfo> = [];
        otherWaitPackagesOrderNumber: string = '';
        showStockReturn: boolean = false;
        showStockSign: boolean = false;
        needCert: boolean = false;
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
            this.getData();
        }
        async playAudio() {
            return;
            var Audio1: any = document.getElementById("Audio1");
            var Audio2: any = document.getElementById("Audio2");
            Audio1.play();
            Audio2.play();
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.logistics.storeId = this.storeaddressList[0].id;
            var data: any = this.$refs.inputshipment;
            data.focus();
        }

        async pdfLinkToBase64(url) {
            try {
                // 使用fetch API获取PDF文件
                const response = await fetch(url);

                // 确保响应成功
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                // 将响应转换为ArrayBuffer
                const arrayBuffer = await response.arrayBuffer();

                // 将ArrayBuffer转换为Base64字符串
                const base64String = this.arrayBufferToBase64(arrayBuffer);

                return base64String;
            } catch (error) {
                console.error('Error fetching the PDF:', error);
                throw error; // 重新抛出错误以便上层调用者可以处理
            }
        }

        // 辅助函数：将ArrayBuffer转换为Base64字符串
        arrayBufferToBase64(buffer) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }

        processPrintList(json) {
            var Options = new Array();
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                document.getElementById('SelectPrint').appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return false;
        }

        async kjprintTxm() {
            var barCode = this.logistics.shelfNumber;
            if (!barCode || barCode.length <= 0) {
                this.$Message.error("货架号不能为空");
                return;
            }
            if (!this.isLoadPrintList) {
                var printWorld = new GetPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
                var json = {
                    action: "", refresh: true, defaultprn: true, error: "", val: {}
                };
                json.action = "printers";
                json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
                json.defaultprn = true;                   //是否包含缺省打印机信息。
                printWorld.CallbackOnPrinterList(this.processPrintList);
                if (!printWorld.Act(json)) {//数据发送失败
                    alert(printWorld.GetLastError());
                }
                return false;
            }

            var pdfData = {
                barCode: "",
                shelfPosition: barCode,
                imageUrl: "",
                url: '',
            };
            this.$store.commit('fontorder/getPdfUrl', pdfData);
            var printSelect: any = document.querySelector('#SelectPrint');
            if (!printSelect.value) {
                this.$Message.success("请选择指定打印机");
                return;
            }

            if (pdfData.url && pdfData.url.length > 0) {
                var printWorld = new GetPrintWorld(); //new 一个打天下对象
                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                //jsons.action = "printfile";
                //jsons.format = "pdf_url";        //指定格式为pdf_url。
                //jsons.content = pdfData.url.replace("https", "http");   //pdf文件的url路径

                var baseData = await this.pdfLinkToBase64(pdfData.url);
                jsons.action = "printfile";
                jsons.format = "file_base64";
                jsons.content = "data:application/pdf;base64," + baseData;

                jsons.paperlength = 15;
                jsons.paperwidth = 10;
                if (this.needCert) {
                    jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                }
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                printWorld.Act(jsons);
            }

        }

        handleSuccess(res, file) {
            if (res.success) {
                this.logistics.imageGuid = res.result;
                var data = { imageGuid: this.logistics.imageGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            }
        }


        appendOrderId() {
            if (this.otherWaitPackagesOrderNumber && this.logistics.shelfNumber && !this.logistics.shelfNumber.endsWith('-' + this.otherWaitPackagesOrderNumber)) {
                this.logistics.shelfNumber = this.logistics.shelfNumber + "-" + this.otherWaitPackagesOrderNumber;
            }
        }
        //async NumberClick(ev) {
        //    if (ev.code == "ArrowLeft") {
        //        this.checkExpress();
        //    }
        //    else if (ev.code == "ArrowRight") {
        //        this.signFor();
        //    }
        //}

        async enter() {
            this.checkExpress();
        }

        setQrCode(val: string) {

            let qrcode = new QRcode('exqrcode', {
                width: 150,
                height: 150, // 高度
                text: window.location.origin + "/#/takephone/logisticsphoto?shipment=" + val, // 二维码内容
            });
            //document.getElementById('qrcode').innerHTML = "";
        }

        async NumberClick(ev) {
            if (ev.code == "ArrowLeft") {
                this.checkExpress();
            }
            else if (ev.code == "ArrowRight") {
                this.signFor();
            }
            else if (ev.code == "ArrowDown") {
                this.stockSign();
            }
        }

        async stockSign() {
            if (!this.checkResult || !this.checkResult.shipment) {
                this.$Modal.error({ title: "错误", content: "未检查快递信息，不允许入库！" });
                return;
            }
            if (!this.checkResult.isReplenish) {
                this.$Modal.error({ title: "错误", content: "此快递不是补单快递，不允许使用囤货入库！" });
                return;
            }
            if (!this.checkResult.isCancle) {
                this.$router.push({ name: 'backstockList', params: { stockShipment: this.checkResult.shipment } });
            }

        }
        async stockReturn() {
            if (!this.checkResult || !this.checkResult.shipment) {
                this.$Modal.error({ title: "错误", content: "未检查快递信息，不允许入库！" });
                return;
            }
            if (!this.checkResult.returnStoreId) {
                this.$Modal.error({ title: "错误", content: "非囤货退货订单！" });
                return;
            }
            await this.$store.dispatch({
                type: 'frontstock/createReturnStore',
                data: { orderId: this.checkResult.returnStoreId, shipNumber: this.checkResult.shipment }
            });

            this.$router.push({ name: 'backstockList', params: { stockShipment: this.checkResult.shipment } });

        }

        async checkExpress() {
            document.getElementById('exqrcode').innerHTML = "";
            this.showStockSign = false;
            this.showStockReturn = false;
            if (this.logistics.shipment) {
                this.logistics.shipment = this.logistics.shipment.toUpperCase();
            }
            var shipMent = this.logistics.shipment;
            if (!shipMent && shipMent.length == 0) {
                this.$Message.error('检查的快递单号不能为空。');
                return;
            }
            if (!this.logistics.storeId) {
                this.$Message.error('仓库不能为空。');
                return;
            }
            setTimeout(() => {
                this.setQrCode(shipMent);
            }, 500);
            var data = { Shipment: shipMent, StoreId: this.logistics.storeId };
            this.clearData();
            this.logistics.shipment = data.Shipment;
            this.logistics.storeId = data.StoreId;
            this.checkLoding = true;
            this.titleList = [];
            this.checkResult = await this.$store.dispatch({
                type: 'backabroadlogistics/getIntoLogisticsCheckResult',
                data: this.logistics
            }).finally(() => {
                this.checkLoding = false;
            });
            if (this.checkResult.isNative) {
                this.isNative = true;
                //this.waerhouseOrderType = 1;
            }
            else {
                //this.waerhouseOrderType = 0;
                this.isNative = false;
            }
            this.checkResult.shipment = data.Shipment;
            this.logistics.userCode = this.checkResult.userCode;
            this.otherWaitPackagesOrderNumber = this.checkResult.otherWaitPackagesOrderNumber;
            if (!this.logistics.userCode) {
                this.logistics.userCode = "XLCK";
            }
            this.logistics.isConfirm = true;
            this.logistics.shelfNumber = this.checkResult.shelfNumber;
            if (this.isNative) {

                this.titleList.push("本土");
                if (this.checkResult.isRemind) {
                    this.$Modal.warning({ title: "提示", content: "用户积分不足300！" });
                    //this.titleList.push("用户积分不足300");
                }
            }
            if (this.checkResult.isReject) {
                this.logistics.shelfNumber = "拒收";
                this.titleList.push("拒收(ปฏิเสธ)");
            }
            if (this.checkResult.returnStoreId) {
                this.titleList.push("囤货退件(สินค้าตีกลับ(สต๊อก))");
                this.showStockReturn = true;
            } else if (this.checkResult.isReturn) {
                this.titleList.push("退件(การส่งคืน)");
            }

            if (this.checkResult.isReplenish) {
                var info = ""
                if (this.checkResult.isCancle) {
                    info = "但此快递在补货中已取消！(แต่การจัดส่งนี้ถูกยกเลิกในการเติม)";
                } else {
                    this.showStockSign = true;
                }
                this.titleList.push("此快递为囤货商品的补货快递！(สินค้าสต๊อก)" + info);
            }
            if (this.checkResult.isReturn) {
                this.checkResult.isHeadless = false;
            }

            if (this.checkResult.isHeadless) {
                this.titleList.push("无头件(ส่วนหัว)");
            } else {
                if (this.checkResult.haveOtherWaitPackagesOrder) {
                    this.titleList.push("关联多订单(เชื่อมโยงหลายคำสั่งซื้อ)");
                }
                if (this.checkResult.isReject) {
                    this.titleList.push((this.checkResult.isCreateOrder ? "无法打包[多包裹未到齐](ไม่สามารถบรรจุได้[พัสดุหลายชิ้นไม่ครบ])" : "无法打包[未创建仓库订单](ไม่สามารถบรรจุได้[ไม่มีการสร้างคำสั่งซื้อคลังสินค้า])"));
                } else if (this.checkResult.isPack) {
                    
                    this.titleList.push("可以打包(สามารถบรรจุได้)");
                    
                 
                }
                else if (this.checkResult.resultMsg && !this.checkResult.isPack) {
                    this.titleList.push("无法打包(ไม่สามารถบรรจุได้)，" + this.checkResult.resultMsg);
                }else {
                    this.titleList.push((this.checkResult.isCreateOrder ? "无法打包[多包裹未到齐](ไม่สามารถบรรจุได้[พัสดุหลายชิ้นไม่ครบ])" : "无法打包[未创建仓库订单](ไม่สามารถบรรจุได้[ไม่มีการสร้างคำสั่งซื้อคลังสินค้า])"));
                }
            }

            if (this.checkResult.isReject) {
                this.shelfNumberInfo = "拒收快递，建议输入货架号";
            }
            else if (this.checkResult.isHeadless) {
                this.shelfNumberInfo = "无头件，建议输入货架号";
            }
            else if (!this.checkResult.isPack) {
                this.shelfNumberInfo = "无法打包，建议输入货架号";
            }
            else if (this.checkResult.isPack && this.checkResult.haveOtherWaitPackagesOrder) {
                this.shelfNumberInfo = "可以打包，但是还有其他关联订单；建议输入货架号";
            }
            else if (this.checkResult.isPack && !this.checkResult.haveOtherWaitPackagesOrder) {
                this.shelfNumberInfo = "关联订单都可以打包，无需输入货架号";
            }
            else {
                this.shelfNumberInfo = '';
            }
            if (this.shelfNumberInfo.indexOf("可以打包") != -1) {
                this.signFor();
            }
            // 无头或者无法打包，并且不是囤货 不是退货订单，并且不是取消订单
            if ((this.checkResult.isHeadless || !this.checkResult.isPack) && !this.checkResult.isReplenish && !this.checkResult.returnStoreId && !this.checkResult.isCancle) {
                if (this.isSkip) {
                    this.clearData();
                }
            }
        }
        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }

        copyShipment() {
            if (!this.logistics.shipment || this.logistics.shipment.length < 0) {
                this.$Message.error('快递单号为空，不能复制。');
            }
            this.copyInfo(this.logistics.shipment);
        }

        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }

        setImage() {
            if (this.logistics.goodsImageGuid && this.logistics.goodsImageGuid.length > 1) {
                var datas = { goodsImageGuid: this.logistics.goodsImageGuid, urls: null };
                this.$store.commit('backlogistics/getGoodsImgUrl', datas);
                this.goodsimgUrl = datas.urls;
            } else {
                this.goodsimgUrl = null;
            }
        }

        handleSuccessGoods(res, file) {
            if (res.success) {
                this.logistics.goodsImageGuid = res.result;
                this.setImage();
            }
        }
        handleErrorGoods(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }


        signFor() {
            if (!this.checkResult || !this.checkResult.shipment) {
                this.$Modal.error({ title: "错误", content: "未检查快递信息，不允许入库！" });
                return;
            }
            if (this.checkResult.shipment != this.logistics.shipment) {
                this.$Modal.error({ title: "错误", content: "检查的快递单号：" + this.checkResult.shipment + "与现在入库的快递单号:" + this.logistics.shipment + "不一致。" });
                return;
            }
            this.logistics.receiveStatus = 1;
            var _this = this;
            if (this.checkResult.isHeadless && (!this.logistics.imageGuid || !this.logistics.goodsImageGuid)) {
                _this.$Modal.confirm({
                    title: "图片不完整", content: "无头件但是没有上传图片,是否继续入库？", width: 800, onOk: async () => {
                        setTimeout(() => {
                            _this.judgeShipment();
                        }, 500);
                    }
                });
            } else {
                _this.judgeShipment();
            }

        }
        judgeShipment() {
            var _this = this;
            if (!this.logistics.shelfNumber || this.logistics.shelfNumber.length == 0) {
                var info: string = null;
                if (this.checkResult.isReject) {
                    info = "拒收快递，建议输入货架号";
                }
                else if (this.checkResult.isHeadless) {
                    info = "无头件，建议输入货架号";
                }
                else if (!this.checkResult.isPack) {
                    info = "无法打包，建议输入货架号";
                }
                else if (this.checkResult.isPack && this.checkResult.haveOtherWaitPackagesOrder) {
                    info = "可以打包，但是还有其他关联订单未到齐；建议输入货架号";
                }
                if (info) {
                    _this.$Modal.confirm({
                        title: "货架号为空", content: info + ",是否继续入库？", width: 800, onOk: async () => {
                            setTimeout(() => {
                                _this.save();
                            }, 500);
                        }
                    });
                }
                else {
                    this.save();
                }

            } else {
                this.save();
            }
        }

        @Watch('$route.params.JumpPage')
        JumpPageChange() {
            if (this.$route.params.JumpPage) {
                var data: any = document.querySelector('input[name="shipmentId"]');
                data.focus();
            }


        }

        save() {
            (this.$refs.logisticsCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    if (!this.selectDate || this.selectDate.length == 0) {
                        var anyDate: any = this.selectDate;
                        this.logistics.processTime = anyDate;
                    }
                    this.logistics.shipment = this.logistics.shipment.trim();
                    await this.$store.dispatch({
                        type: 'backabroadlogistics/updateLogistics',
                        data: this.logistics
                    });
                    if (this.checkResult.isPack && !this.checkResult.isReject && !this.checkResult.isReturn) {
                        this.copyInfo(this.logistics.shipment);
                        //this.$Modal.success({ title: "快递入库成功", content: "快递入库成功，已帮你复制好快递单号，即将跳转订单管理列表！" });
                        this.$Message.success("快递入库成功");
                        var shipment = this.logistics.shipment;
                        this.playAudio();
                        this.$router.push({ name: 'backabroadorder', params: { inputShipment: shipment } });
                        
                        this.clearData();
                    } else {
                        this.clearData();
                        //this.$Modal.success({title:"快递入库成功",content:"快递入库成功！"});
                        this.$Message.success("快递入库成功");
                    }

                }
            })
        }

        clearData() {
            (this.$refs.logisticsCreateForm as any).resetFields();
            this.logistics.goodsImageGuid = null;
            this.logistics.imageGuid = null;
            this.goodsimgUrl = null;
            this.imgUrl = null;
            if (this.storeaddressList.length > 0) {
                this.logistics.storeId = this.storeaddressList[0].id;
            }
            this.checkResult = null;
        }

    
        cancel() {
            (this.$refs.logisticsCreateForm as any).resetFields();
        }

        logisticsRule = {
            storeId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            shipment: [
                { required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            userCode: [
                { required: true, max: 30, message: '用户编码不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ]
        };

    }
